import { createFileRoute } from '@tanstack/react-router';
import { AutomationPageView } from '@/components/marketing/AutomationPage';
import { automationHead } from '@/content/aiAutomation';
export const Route = createFileRoute('/ai-automation/workflows')({head: () => automationHead('workflows'), component: WorkflowsPage});
function WorkflowsPage() { return <AutomationPageView pageKey="workflows" />; }